module.exports = __webpack_public_path__ + "static/img/carpic.bb62908.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/carpic.png
// module id = sTuq
// module chunks = 1